export const validation = {
  name_es: 'required|min:3|max:255',
  name_en: 'min:3|max:255',
  code: 'min:1|max:5|alpha',
  type_id: 'required|min_value:1|numeric|max:11',
  status_id: 'required|min_value:1|numeric|max_value:9'
}

export const attributeFields = function () {
  return {
    name_es: null,
    name_en: null,
    code: null,
    type_id: null,
    image: null,
    status_id: null
  }
}

export const statusList = [
  {
    id: 1,
    name: 'Activo'
  },
  {
    id: 2,
    name: 'Inactivo'
  }
]

export const texts = {
  attributeEdit: {
    title: 'Editar Atributo Existente',
    subtitle: 'Edita la información del atributo de producto.',
    submit: 'Actualizar Atributo',
    messages: {
      success: {
        title: 'ATRIBUTO ACTUALIZADO',
        text: 'Este attributo ha sido actualizado correctamente'
      }
    }
  },
  attributeNew: {
    title: 'Añadir Nuevo Atributo',
    subtitle: 'Crear nuevo atributo de producto',
    submit: 'Crear Atributo',
    messages: {
      success: {
        title: 'ATRIBUTO CREADO',
        text: 'Se ha creado correctamente el nuevo attributo de producto'
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/products/attributes/mocks.js